import Hubspot from "../../../../contents/docs/cdp/sources/_snippets/source-hubspot.mdx";
import * as React from 'react';
export default {
  Hubspot,
  React
};